import { Link, usePage } from '@inertiajs/react';
import { parishName, parishLogo, useSite } from '@/hooks/useSite';

interface AdminPageProps {
  auth: { user: { email: string; name: string | null; avatarUrl: string | null } | null };
  [key: string]: unknown;
}

export function StatsHeader() {
  const { auth } = usePage<AdminPageProps>().props;
  const site = useSite();
  const user = auth.user;
  const displayName = user?.name?.trim() || user?.email || '';
  const initial = displayName ? displayName[0].toUpperCase() : '?';

  return (
    <header className="border-line bg-surface flex shrink-0 items-center justify-between border-b px-6 py-3">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <img
          src={parishLogo(site)}
          alt={`Brasão de ${parishName(site)}`}
          className="h-[44px] w-auto flex-shrink-0"
        />
        <div className="bg-line h-5 w-px flex-shrink-0" />
        <div className="flex flex-col leading-tight">
          <span className="font-headline text-on-surface text-[13px] font-extrabold tracking-tight">
            {parishName(site)}
          </span>
          <span className="font-body text-on-surface-light text-[10px] font-medium tracking-[0.06em]">
            Painel de Administração
          </span>
        </div>
      </div>

      {/* Right cluster: profile link (avatar · name) · logout */}
      <div className="flex items-center gap-3">
        {/* Profile link */}
        <Link
          href="/profile"
          className="hover:bg-background flex items-center gap-2.5 rounded-md px-2 py-1 transition-colors"
          aria-label="O meu perfil"
        >
          {user?.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt=""
              className="border-line h-7 w-7 flex-shrink-0 rounded-full border object-cover"
            />
          ) : (
            <span className="bg-primary flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold text-white">
              {initial}
            </span>
          )}
          <span className="text-on-surface-light text-sm font-medium">{displayName}</span>
        </Link>

        {/* Logout button */}
        <Link
          href="/users/sign_out"
          method="delete"
          as="button"
          aria-label="Terminar sessão"
          title="Terminar sessão"
          className="text-on-surface-light hover:bg-primary/5 hover:text-primary flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md transition-colors"
        >
          <span className="material-symbols-outlined text-[18px]">logout</span>
        </Link>
      </div>
    </header>
  );
}
